import API from "..";

export default class SpecialAnalysisBusinessUnit {

  constructor({
    businessUnitName,
    isActive
  }) 
    
  {
    this.businessUnitName = businessUnitName;
    this.isActive = isActive;
  }

  static async getAll() {
    const api = await API();
    const { data } = await api.get(`/specialAnalysisBusinessUnit`);
    if (data.result) {
        return data.result.map((d) => new SpecialAnalysisBusinessUnit(d));
    }
    else {
        return [];
    }
  }

  static async getAllActive() {
    const api = await API();
    const { data } = await api.get(`/specialAnalysisBusinessUnit`);
    if (data && data.result && data.result.length >0) {
        return data.result.filter((d) => d.isActive);
    }
    else {
        return [];
    }
  }
}
